import React, { Fragment } from 'react';
import { Box, Stack, Radio, Grid, RadioGroup } from '@mui/material';
import { StyledDataGrid, StyledCard, StyledCardTitle, TableBadge, DataGridProps, FlexDiv, CustomRadio } from '../../../../../custom/components';
import { EditIcon, LockIcon, LocationIcon, UnlockIcon, AddIcon, DeleteIcon } from '../../../../../custom/constants';
import AirlineStyles from './airlines.module.css';
import styles from '../../../../../custom/style.module.css';
import LocationContainer from 'components/pages/common/location/LocationContainer';
import AirlineModal from './AirlineModal';
import TanStackTableWrapper from '../../../common/TanStackTableWrapper';

const HandledAirlines = (props) => {
  const { airlineList, handleOpen, setActive } = props;
  const columns = [
    {
      field: 'name',
      headerName: 'Airline Name',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'code',
      headerName: 'Airline Code',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'awb_pre',
      headerName: 'Airwaybill Prefix',
      minWidth: 100,
      flex: 1,

    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      align: 'center',
      minWidth: 100, 
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (data) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='center' className={styles.actionIcons}>
            <div onClick={() => setActive(data.row.id, !data.row.active)}>
              {data.row.active ? <LockIcon title='Deactivate Airline' /> : <UnlockIcon title='Reactivate Airline' />}
            </div>
            <TableBadge color='error' badgeContent={data.row.stations && data.row.stations.length}>
              <div onClick={(e) => props.handleLocation('airline/update', true, data.row, e.target)}>
                <LocationIcon />
              </div>
            </TableBadge>
            <div onClick={() => handleOpen('edit', data.row, 'airlines')} >
              <EditIcon />
            </div>
          </Stack>
        );
      }
    },
  ];
  const combination_columns = [
    {
      accessorKey: 'name',
      header: 'Alliance Name',
      cell: ({ row }) => <div>{row.original.name}</div>,
    },
    {
      accessorKey: 'code',
      header: 'Alliance Code',
      cell: ({ row }) => <div>{row.original.code}</div>,
    },
    {
      accessorKey: 'airlineNames',
      header: 'Airlines',
      enableSorting: false,
      cell: ({ row }) => {
        const airlines = Array.isArray(row.original.airlines) ? row.original.airlines : [];
        return (
          <Stack direction='column' spacing={0.5}>
            {airlines.map(airline => (
              <div key={airline.id}>
                - {airline.name}
              </div>
            ))}
          </Stack>
        );
      }
    },
    {
      accessorKey: 'action',
      header: 'Action',
      align: 'center',
      enableSorting: false,
      cell: ({ row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='center' className={`${styles.actionIcons} ${AirlineStyles.alignTopCell}`}>
            {/* <div onClick={() => setActive(data.row.id, !data.row.active)}>
              {data.row.active ? <LockIcon title='Deactivate Airline' /> : <UnlockIcon title='Reactivate Airline' />}
            </div> */}
            <div onClick={() => props.handleCombineEdit(row.original)} >
              <EditIcon title='Edit Airline Alliance' />
            </div>
            <div>
              <DeleteIcon title='Delete Airline Alliance' onClick={(e) => { props.deleteAirlineCombination(row.original.id, e.target); }} />
            </div>
          </Stack>
        );
      }
    },
  ];
  const getTabs = () => {
    let tabs = [
      {
        label: 'Airlines',
        value: 'airlines'
      },
      {
        label: 'Combine airlines',
        value: 'combineAirlines',
      },
    ];
    return tabs.map((value, index) => {
      return <Fragment key={index}>
        <CustomRadio value={value.value}
          control={<Radio className={styles.radioToggleBtn} />}
          label={value.label}
          className={`${styles.radioToggle} ${props.tab === value.value ? styles.radioToggleBtnChecked : ''}`}
          classes={{ label: styles.radioToggleLabel }}
        />
      </Fragment>;
    });
  };

  return (
    <div>
      <RadioGroup
        aria-label='Airline section'
        name='airline-section'
        value={props.tab}
        row
        onChange={props.onChangeTab}
        className={styles.radioToggleGroup}
        sx={{
          display: {
            xs: 'flex',
            lg: 'none' 
          },
          mb: 2 
        }}
      >
        {getTabs()}
      </RadioGroup>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6} sx={{
          display: {
            xs: props.tab === 'airlines' ? 'block' : 'none',
            lg: 'block' 
          } 
        }}>
          <StyledCard>
            <FlexDiv><StyledCardTitle>Handled Airlines</StyledCardTitle></FlexDiv>
            <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-24px'}>
              <AddIcon className={styles.addIcon} title='Add Airline' onClick={() => props.handleOpen('add', {}, 'airlines')} />
            </Stack>

            <div className={styles.tableWrapper}>
              <Box className={`${styles.tableOuter} ${AirlineStyles.airlineTableOuter}`}>
                <StyledDataGrid
                  {...DataGridProps}
                  rows={airlineList}
                  columns={columns}
                  param={airlineList?.length}
                />
              </Box>
            </div>
          </StyledCard>
        </Grid>
        <Grid item xs={12} lg={6} sx={{
          display: {
            xs: props.tab === 'combineAirlines' ? 'block' : 'none',
            lg: 'block' 
          } 
        }}>
          <StyledCard>
            <FlexDiv><StyledCardTitle> Airline Alliance</StyledCardTitle></FlexDiv>
            <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-24px'}>
              <AddIcon className={styles.addIcon} title='Add Airline Alliance' onClick={() => props.handleOpen('add', {}, 'combineAirlines')} />
            </Stack>

            <div className={styles.tableWrapper}>
              <Box className={`${styles.tableOuter} ${AirlineStyles.airlineTableOuter}`}>
                <TanStackTableWrapper columns={combination_columns} data={props.combinationList} />
              </Box>
            </div>
          </StyledCard>
        </Grid>
      </Grid>

      <AirlineModal
        addAirline={props.addAirline}
        onChange={props.onChange}
        handleClose={props.handleClose}
        openAddAirline={props.openAddAirline}
        airlineFields={props.airlineFields}
        handleOpen={props.handleOpen}
        airlineErrors={props.airlineErrors}
        type={props.type}
        tab={props.tab}
        
        // combine airline props
        airlineList={props.comboairlineList}
        combinationList={props.combinationList}
        combineAirlineFields={props.combineAirlineFields}
        combineAirlineErrors={props.combineAirlineErrors}
        combineAirline={props.combineAirline}
        onChangeCombineAirline={props.onChangeCombineAirline}
        addAirlineCombination={props.addAirlineCombination}
        updateAirlineCombination={props.updateAirlineCombination}
        deleteAirlineCombination={props.deleteAirlineCombination}
        handleCombineEdit={props.handleCombineEdit}
        onToggleType={props.onToggleType}
      />
          
      <LocationContainer
        anchorEl={props.anchorEl}
        open={props.location}
        type={props.locationType}
        handleClose={props.handleLocation}
        name={props.station.name}
        stations={props.stations}
        data={props.station}
      />
    </div>
  );
};

export default HandledAirlines;